import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { Icon } from '@iconify/react';


const GiftingIdeas =()=>{
    const redirectUrl=[
        {redirectText: "Custom Gift Sets", redirectURL:'/contact-us'},
        {redirectText: "Premium Branded Products", redirectURL:'/contact-us'},
        {redirectText: "Popular Brand Gifts", redirectURL:'/contact-us'},
        {redirectText: "Decadent Treats", redirectURL:'/contact-us'},
        {redirectText: "Cutting-Edge Tech Gadgets", redirectURL:'/contact-us'},
           
    ]
    return(
        <>
            <div className="mt-5 mb-5" style={{
                backgroundImage: 'url(./assests/images/giftingIdeas.png)',
                backgroundRepeat:"no-repeat",
                backgroundSize:'inherit',
                width:'auto',
                // height:'702px',
                backgroundColor:'#F8F4F1',
                borderTop:"1px solid #C6C6C6",
                borderBottom:"1px solid #C6C6C6"
            }}>
                <Container>
                    <Row className="" >
                        <Col md={6} className="pt-5 pb-5" >
                            <h2 className="text-white" id="headingFontSize">Corporate Gifting Made Simple</h2>
                            <p className="fs-14 text-white w-md-80">
                                Strengthen your brand presence by offering personalized, high-quality merchandise that resonates with your audience and enhances your brand identity. 
                            </p>
                            <Link to="/contact-us">
                            <Button id="whiteBtn" className="rouned fs-16">
                                Connect with us
                            </Button>
                            </Link>
                            
                        </Col>
                        <Col md={6} className="bgeYantra pt-5 pb-5 ps-md-5 h-100"  >
                           <h2 id="headingFontSize">Gifting Ideas:-</h2>
                        {redirectUrl.map((item, inde)=>
                            <div className="d-flex border border-dark rounded ps-4 pe-4 p-2 mt-3 justify-content-between align-items-center">
                            <h3 className="m-0 p-0 fs-30">
                                 <Link to={item.redirectURL} className="text-decoration-none text-dark">
                                     {item.redirectText}
                                 </Link>
                            </h3>
                                 {/* <Icon icon="tabler:arrow-narrow-right" width="24" height="24" /> */}
                            </div>
                        
                        )}
                        
                        </Col>
                        
                    </Row>
                    

                </Container>


            </div>
        
        </>
    )
}

export default GiftingIdeas;